/**
 * DTM Chart Design Tokens
 * Shared constants for all chart components. Matches the card generator visual language.
 */

// Core palette
export const TOKENS = {
  bg: "#0d0d0d",
  bgInline: "transparent",
  ink: "#ffffff",
  muted: "#888888",
  grid: "#1a1a1a",
  green: "#ccff00",
  greenDim: "rgba(204,255,0,0.15)",
  greyBar: "#333333",

  // Position colors
  pos: {
    QB: "#ff6b6b",
    RB: "#4ecdc4",
    WR: "#45b7d1",
    TE: "#f9ca24",
  },

  // Semantic
  accent: "#ccff00",
  accentDim: "rgba(204,255,0,0.12)",
  highlight: "#ccff00",
  dimBar: "#262626",
  negative: "#ff4d4d",
  positive: "#4ecdc4",

  // Fonts
  display: "'Bebas Neue', sans-serif",
  body: "'Manrope', sans-serif",
  mono: "'JetBrains Mono', monospace",

  // Chart dimensions
  tooltipStyle: {
    background: "#171717",
    border: "1px solid #262626",
    borderRadius: "2px",
    fontSize: 11,
    fontFamily: "'Manrope', sans-serif",
    color: "#ffffff",
  },
};

// Standalone (social card) dimensions
export const STANDALONE = {
  square: { width: 1080, height: 1080 },
  wide: { width: 1600, height: 900 },
};

/** Wrapper for chart figure + caption */
export function ChartFigure({ title, subtitle, source, children, className = "" }) {
  return (
    <figure className={`border border-[#262626] bg-[#171717] rounded-sm overflow-hidden ${className}`}>
      {(title || subtitle) && (
        <div className="px-5 pt-4 pb-2">
          {title && (
            <h3 className="text-[10px] font-bold uppercase tracking-wider text-[#ccff00] mb-0.5">{title}</h3>
          )}
          {subtitle && (
            <p className="text-[10px] text-[#555]">{subtitle}</p>
          )}
        </div>
      )}
      <div className="px-3 pb-3">{children}</div>
      {source && (
        <figcaption className="px-5 pb-3 text-[10px] text-[#444]">
          Source: {source}
        </figcaption>
      )}
    </figure>
  );
}
